import { Flex, Box, Text } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useQueueStore } from '../context/use-queue-store';

export const QueueFilterIndicator = observer(function QueueFilterIndicator(): React.ReactElement {
    const store = useQueueStore();
    return store.isFiltered ? (
        <Box w="100%" backgroundColor="surface.canvas">
            <Flex
                w="100%"
                h="30px"
                position="sticky"
                top="21"
                justifyContent="center"
                alignItems="center"
                textAlign="center"
            >
                <Text variant="headingXs">Not all rows in this queue are currently visible.</Text>
                <Box
                    marginLeft={1}
                    cursor="pointer"
                    onClick={() => {
                        store.clearFilterQuery();
                    }}
                >
                    <Text variant="headingXs" decoration="underline">
                        Clear Search
                    </Text>
                </Box>
            </Flex>
        </Box>
    ) : (
        <></>
    );
});
